import { createFileRoute } from '@tanstack/react-router'
import { PageHeader } from '@/shared/components/layout/PageHeader'
import { OrgNotificationDefaults } from '@/features/notification-preferences'

function NotificationDefaultsPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Notification Defaults" />
      <OrgNotificationDefaults />
    </div>
  )
}

export const Route = createFileRoute('/settings/notification-defaults')({
  component: NotificationDefaultsPage,
  staticData: { authorize: true },
})
